import { Assessment } from '../types';

export const assessments: Assessment[] = [
  {
    id: 'pa',
    name: 'Privacy Applicability Assessment (PAA)',
    shortName: 'PAA',
    description: 'Initial analysis to identify global privacy regulations applicable to your business activities.',
    price: 399,
    features: [
      'Identify applicable privacy laws',
      'Identify privacy risk exposure',
      'Applicability Report',
      'Available for Europe, Americas, Africa, Asia, and Oceania regions'
    ],
    estimatedTime: '1-3 business days'
  },
  {
    id: 'pia',
    name: 'Privacy Impact Assessment (PIA)',
    shortName: 'PIA',
    description: 'Comprehensive analysis of privacy risks and impacts for specific processing activities.',
    price: 999,
    features: [
      'Detailed privacy risk analysis',
      'Identify privacy risk exposure',
      'Mitigation recommendations',
      'Risk Register report',
      'Available for Europe, Americas, Africa, Asia, and Oceania regions'
    ],
    estimatedTime: '1-3 business days'
  },
  {
    id: 'dpia',
    name: 'Data Protection Impact Assessment (DPIA)',
    shortName: 'DPIA',
    description: 'In-depth evaluation of high-risk processing activities as required by GDPR.',
    price: 1499,
    features: [
      'Detailed high-risk analysis',
      'Technical controls assessment',
      'Mitigation recommendations',
      'Article 30 ROPA report',
      'Available for Europe, Americas, and Asia regions'
    ],
    estimatedTime: '3-5 business days'
  },
  {
    id: 'tra',
    name: 'Transfer Risk Assessment (TRA)',
    shortName: 'TRA',
    description: 'Assesses risks associated with international data transfers.',
    price: 899,
    features: [
      'Transfer mechanism evaluation',
      'Country risk assessment',
      'Safeguard analysis',
      'Recommendations report'
    ],
    estimatedTime: '4-6 business days'
  },
  {
    id: 'tia',
    name: 'Transfer Impact Assessment (TIA)',
    shortName: 'TIA',
    description: 'Comprehensive analysis of data transfer impacts and compliance requirements.',
    price: 1299,
    features: [
      'Impact evaluation',
      'Cross-border requirements',
      'Risk mitigation strategies',
      'Documentation support'
    ],
    estimatedTime: '6-8 business days'
  },
  {
    id: 'lia',
    name: 'Legitimate Interests Assessment (LIA)',
    shortName: 'LIA',
    description: 'Evaluates the legitimacy of data processing based on business interests.',
    price: 699,
    features: [
      'Purpose assessment',
      'Necessity evaluation',
      'Balancing test',
      'Documentation support'
    ],
    estimatedTime: '3-5 business days'
  },
  {
    id: 'pga',
    name: 'Privacy Gap Analysis (PGA)',
    shortName: 'PGA',
    description: 'Identifies gaps between current privacy practices and regulatory requirements.',
    price: 799,
    features: [
      'Current state analysis',
      'Regulatory requirement mapping',
      'Gap identification',
      'Remediation planning'
    ],
    estimatedTime: '4-6 business days'
  },
  {
    id: 'csa',
    name: 'Cybersecurity Assessment (CSA)',
    shortName: 'CSA',
    description: 'Comprehensive evaluation of security controls, vulnerabilities, and data protection measures.',
    price: 1699,
    features: [
      'Security controls review',
      'Vulnerability assessment',
      'Data protection analysis',
      'Security roadmap',
      'Risk mitigation plan'
    ],
    estimatedTime: '8-10 business days'
  },
  {
    id: 'tprm',
    name: 'Third Party Risk Management (TPRM)',
    shortName: 'TPRM',
    description: 'Evaluates privacy and security risks associated with third-party vendors and service providers.',
    price: 1299,
    features: [
      'Vendor risk assessment',
      'Data processing review',
      'Contract compliance check',
      'Due diligence verification',
      'Risk remediation guidance'
    ],
    estimatedTime: '6-8 business days'
  }
];